module.exports = __webpack_public_path__ + "img/ajyc.e485eda2.png";